<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="900px"
    transition="dialog-transition"
  >
    <v-card v-if="selectedItem && show">
      <v-card-title class="grey lighten-3">
        <v-row align="center">
          <v-icon class="draggable">mdi-drag</v-icon>
          <v-col class="py-0" cols="10" style="text-wrap: nowrap">
            <span
              ><v-icon class="mr-3">{{
                supplierTypeIcon(selectedItem.serviceType)
              }}</v-icon></span
            >
            {{ selectedItem.supplierName }} - {{ selectedItem.rateTypeCode }} -
            {{ selectedItem.startDate | formatDate }} -
            {{ selectedItem.endDate | formatDate }}
          </v-col>
          <v-col class="py-0">
            <v-container py-0
              ><v-row justify="end">
                <v-btn icon color="indigo" @click="onCancel">
                  <v-icon>mdi-close</v-icon>
                </v-btn></v-row
              ></v-container
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="pa-3">
        <h4 class="title">
          {{ selectedItem.qty }}
          x {{ selectedItem.serviceName }}, Adults: {{ selectedItem.adults }},
          Children: {{ selectedItem.children }}, Infants:
          {{ selectedItem.infants }}
        </h4>
        <v-row v-if="!isExtra">
          <v-col>
            <business-model-list-select
              v-model="businessModel"
              :outlined="outlinedInputs"
              hide-detalils
            ></business-model-list-select>
          </v-col>
          <v-col>
            <v-text-field
              v-model.number="supplierCommission"
              label="Supplier Commission %"
              type="number"
              :outlined="outlinedInputs"
              hide-details=""
              :disabled="!bmUseCommission"
            ></v-text-field>
          </v-col>
        </v-row>
        <item-pricing-form
          :key="pricingFormKey"
          :selected-item="selectedItem"
          @onChange="onChangeListener"
        ></item-pricing-form>
        <div v-if="debug">
          <pre>
                    {{ selectedItem }}
          </pre>
        </div>
        <pricing-logs-dialog
          :show="showPricingLog"
          @close="showPricingLog = false"
          v-model="logs"
        />
      </v-card-text>
      <v-card-actions class="grey lighten-4">
        <v-spacer></v-spacer>
        <v-btn
          color="green"
          text
          @click="onPriceUpdate"
          v-if="showUpdatePrice"
          :loading="priceUpdating"
          >Update price</v-btn
        >
        <v-btn color="warning" text @click="onCancel">Cancel</v-btn>
        <v-btn @click="onShowLogs">Logs</v-btn>
        <v-btn
          color="primary"
          v-if="!readOnly && showSaveButton"
          @click="onSave"
          :disabled="isPercentPriceExtra"
          >Save Changes</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ItemPricingForm from "./ItemPricingForm";
import { SupplierTypeIconMixin } from "../../../../../mixins/SupplierTypeIconMixin";
import BusinessModelListSelect from "../../../shared/BusinessModelListSelect";
import PricingLogsDialog from "./PricingLogsDialog.vue";
import { EXTERNAL_ITEM_PRICING } from "../ItineraryBuilderItemsListItemEditor.vue";
const randomize = require("randomatic");
const moment = require("moment");
import gql from "graphql-tag";
const BUSINESS_MODEL_INFO = gql`
  query businesModelInfo($filter: BusinessModelFilterType) {
    businessModelInfo: businessModels(filter: $filter) {
      edges {
        node {
          id
          name
          code
          commission
        }
      }
    }
  }
`;
export default {
  name: "ItemPricingDialog",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    selectedItem: {
      type: Object,
      default: () => {},
    },
    headerProps: {
      type: Object,
      default: () => {},
    },
    readOnly: {
      type: Boolean,
      default: () => false,
    },
  },

  components: {
    ItemPricingForm,
    BusinessModelListSelect,
    PricingLogsDialog,
  },

  mixins: [SupplierTypeIconMixin],

  data() {
    return {
      debug: false,
      pricingFormKey: randomize("Aa0", 32),
      pricing: this.selectedItem
        ? {
            customPricing: this.selectedItem.customPricing,
            ...this.selectedItem.pricing,
          }
        : {},
      totalPrice: this.selectedItem ? this.selectedItem.price : 0,
      businessModel: this.selectedItem
        ? this.selectedItem.businessModel
        : "BM1",
      supplierCommission: this.selectedItem
        ? this.selectedItem.supplierCommission
        : 0,
      showPricingLog: false,
      currentPricingItem: null,
      priceUpdating: false,
      logs:
        this.pricing && this.pricing.logs && this.pricing.logs.length > 0
          ? [...this.pricing.logs]
          : [],
    };
  },

  watch: {
    selectedItem(data) {
      this.pricing = { ...data.pricing, customPricing: data.customPricing };
      this.businessModel = data.businessModel;
      this.supplierCommission = data.supplierCommission;
      this.pricingFormKey = randomize("Aa0", 32);
      this.logs =
        this.pricing && this.pricing.logs && this.pricing.logs.length > 0
          ? [...this.pricing.logs]
          : [this.getLog()];
    },
  },

  computed: {
    showSaveButton() {
      return this.$store.getters.hasAccessTo("itineraries:edit_prices", true);
    },
    showUpdatePrice() {
      return (
        this.selectedItem &&
        !this.selectedItem.isExtra &&
        this.selectedItem.isExternal
      );
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    isExtra() {
      return this.selectedItem && this.selectedItem.isExtra;
    },
    isPercentPriceExtra() {
      if (this.isExtra) {
        const extra = this.selectedItem.extras.find(
          (e) => e.id == this.selectedItem.extraId
        );
        console.log("extra", extra);
        return extra && Number(extra.percentPrice) > 0;
      } else {
        return false;
      }
    },
    isExternal() {
      return this.selectedItem && this.selectedItem.isExternal;
    },
    bmUseCommission() {
      return (
        this.businessModelInfo &&
        this.businessModelInfo.edges &&
        this.businessModelInfo.edges.length > 0 &&
        this.businessModelInfo.edges[0].node.commission
      );
    },
  },

  methods: {
    onPriceUpdate() {
      if (!Array.isArray(this.selectedItem.extras)) {
        this.selectedItem.extras = [];
      }
      this.priceUpdating = true;
      this.currentPricingItem = this.getPricingParamsFor(this.selectedItem);
    },
    getPricingParamsFor(item) {
      console.log("getPricingParamsFor", item);
      return {
        serviceId: item.serviceId,
        rsResultServiceId: item.source.id,
        department: this.headerProps.departmentName,
        agentId: this.headerProps.agentId,
        ratePlan: "",
        adults: parseInt(item.adults),
        children: parseInt(item.children),
        infants: parseInt(item.infants),
        qty: parseInt(item.qty),
        startDate: item.startDate,
        endDate: item.endDate,
        extras: item.extras.map((e) => {
          let extraQty = e.qty;
          if (e.rateBase == "P") {
            if (e.isChildOnly && e.children) {
              extraQty = Number(e.children);
            } else if (e.isInfantOnly && e.infants) {
              extraQty = Number(e.infants);
            } else if (e.adults) {
              extraQty = Number(e.adults);
            }
          }
          return {
            id: e.id,
            qty: extraQty,
            startDate: e.startDate,
            endDate: e.endDate,
          };
        }),
        yearShift: null,
      };
    },
    getLog() {
      const supplierComp = this.selectedItem
        ? Number(this.selectedItem.supplierComp)
        : 0;
      const passComp = this.selectedItem
        ? Number(this.selectedItem.passComp)
        : 0;
      const {
        rateTypeCode,
        itemBuy,
        itemSell,
        adultBuy,
        adultSell,
        childBuy,
        childSell,
        infantBuy,
        infantSell,
        currencyBuy,
        currencySell,
        currencyBuyExchangeRate,
        currencySellExchangeRate,
      } = this.pricing;
      const supplierCommission = this.supplierCommission;
      return {
        date: moment().format("YYYY-MM-DD"),
        time: moment().format("HH:mm"),
        username: this.$store.getters.userConfig.username,
        rateType: rateTypeCode,
        itemBuy,
        itemSell,
        adultBuy,
        adultSell,
        childBuy,
        childSell,
        infantBuy,
        infantSell,
        currencyBuy,
        currencySell,
        currencyBuyExchangeRate,
        currencySellExchangeRate,
        supplierCommission,
        supplierComp,
        passComp,
      };
    },
    onShowLogs() {
      this.showPricingLog = true;
    },
    onSave() {
      const { customPricing, ...pricing } = this.pricing;
      this.logs.push(this.getLog());
      pricing.logs = [...this.logs];
      this.$emit("onSave", {
        id: this.selectedItem.id,
        customPricing,
        pricing,
        businessModel: this.businessModel,
        supplierCommission: this.supplierCommission,
        totalPrice: this.totalPrice,
        customPricing: true,
        itemId: this.selectedItem.itemId,
        extraId: this.selectedItem.extraId,
        isExtra: this.selectedItem.isExtra,
        yearShift: 0,
      });
    },
    onCancel() {
      this.$emit("onCancel");
    },
    onChangeListener(payload) {
      this.totalPrice = payload.totalPrice;
      this.pricing = payload.pricing;
    },
    pricingFromExtra() {
      return {
        customPricing: false,
        adultBuy: 100,
        adultSell: 110,
        childBuy: 0,
        childSell: 0,
        infantBuy: 0,
        infantSell: 0,
        itemBuy: 100,
        itemSell: 110,
        rateTypeCode: "PPPD",
        currencyBuy: "EUR",
        currencyBuyExchangeRate: 1,
        currencySell: "EUR",
        currencySellExchangeRate: 1,
        itemBased: false,
        discountCost: 0,
        discountSell: 0,
        pricingDays: [
          {
            allocation: "",
            adultSell: 110,
            childSell: 0,
            itemSell: 110,
            discountPercent: 0,
            discountCost: 0,
            discountSell: 0,
            __typename: "ItineraryItemPricingDay",
          },
        ],
      };
    },
  },
  apollo: {
    externalItemPricing: {
      query: EXTERNAL_ITEM_PRICING,
      variables() {
        return { ...this.currentPricingItem };
      },
      manual: true,
      skip() {
        return this.currentPricingItem == null;
      },
      result({ data, loading }) {
        console.log("external item pricing", data, loading);
        if (data && data.externalItemPricing) {
          console.log("this.selectedItem", this.selectedItem);
          ["adult", "child", "infant", "item"].forEach((unit) => {
            this.selectedItem.pricing[unit + "Buy"] =
              data.externalItemPricing[unit + "Buy"];
            this.selectedItem.pricing[unit + "Sell"] =
              data.externalItemPricing[unit + "Sell"];
          });
          this.pricingFormKey = randomize("Aa0", 32);
          this.priceUpdating = false;
        }
        console.log("this.selectedItem updated", this.selectedItem);
      },
      error(err) {
        this.errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
      },
      fetchPolicy: "network-only",
    },
    businessModelInfo: {
      query: BUSINESS_MODEL_INFO,
      variables() {
        return {
          filter: {
            code_eq: this.businessModel,
          },
        };
      },
      skip() {
        return !this.businessModel || this.businessModel == "";
      },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/tools/ItemPricingDialog.vue